<template>
  <div class="register-container">
    <el-card class="register-card">
      <h3 slot="header">用户注册</h3>
      <el-form :model="registerForm" status-icon  :rules="registerRules" ref="registerForm" label-width="80px" class="register-form">

        <el-form-item label='公司名称'  prop ='companyname'>
            <el-autocomplete
              v-model="registerForm.companyname"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="handleSelect"
              style='width:100%'
            ></el-autocomplete>
        </el-form-item>

        <el-form-item label="用户名" prop="account">
          <el-input v-model='registerForm.account' @change="validate" ></el-input>
        </el-form-item>

        <el-form-item label="账号类型" prop="accounttype">
        <el-select   v-model="registerForm.accounttype" placeholder="请选择设备类型"  style="width:100%">
          <el-option label="消防吊桶" value="2"></el-option>
          <el-option label="清洗喷枪" value="1"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phonenumber">
          <el-input v-model='registerForm.phonenumber' @change="validatePhone" ></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="code">
          <el-input v-model="registerForm.code" placeholder="请输入验证码" class="input-with-select">
            <el-button slot="append" @click="getVerificationCode" :disabled="codeTimer > 0">
              {{ codeTimer > 0 ? `${codeTimer}s后重发` : '获取验证码' }}
            </el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="registerForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="registerForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" style="width:100%;" @click="handleRegister">注 册</el-button>
        </el-form-item>

        <div class="register-footer">
          <el-link type="primary" @click="$router.push('/')">已有账号，去登录</el-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from '../../utils/request'
import router from '../../router/index'
export default {
  name: 'Register',
  data () {
    // 自定义手机号校验规则
    var checkPhone = (rule, value, callback) => {
      const key = 'message' + value
      if (!value) {
        callback(new Error('手机号不能为空'))
      }
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        if (localStorage.getItem('phone') === value) {
          if (localStorage.getItem(key) === '该手机号已存在') {
            callback(new Error('该手机号已存在'))
          } else {
            callback()
          }
        } else {
          axios.get(`/data/account/validatephone?phone=${value}`).then(res => {
            console.log('message', res)
            if (res.data === '该手机号已存在') {
              localStorage.setItem('phone', value)
              callback(new Error(res.data))
              localStorage.setItem(key, '该手机号已存在')
            } else {
              callback()
              localStorage.setItem('phone', value)
              localStorage.setItem(key, '')
            }
          })
        }
        // callback()
      }
    }

    var checkusername = (rule, value, callback) => {
      const key = 'acc_message' + value
      if (!value) {
        callback(new Error('用户名不能为空'))
      } else {
        if (localStorage.getItem('account') === value) {
          if (localStorage.getItem(key) === '该用户名已存在') {
            callback(new Error('该用户名已存在'))
          } else {
            callback()
          }
        } else {
          axios.get(`/data/account/validate?account=${value}`).then(res => {
            console.log('message', res)
            if (res.data === '该用户名已存在') {
              localStorage.setItem('account', value)
              callback(new Error(res.data))
              localStorage.setItem(key, '该用户名已存在')
            } else {
              localStorage.setItem('account', value)
              localStorage.setItem(key, '')
              callback()
            }
          })
        }
        // callback()
      }
    }

    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    var checkCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        axios.get(`/data/register/verifycode?code=${value}&phone=${this.registerForm.phonenumber}`).then(res => {
          console.log('message', res)
          if (res.data === '验证码已过期或不存在') {
            callback(new Error(res.data))
          } else if (res.data === '验证码错误') {
            callback(new Error(res.data))
          } else {
            callback()
          }
        })
      }
    }

    return {
      registerForm: {
        companyname: '',
        account: '',
        phonenumber: '',
        code: '',
        password: '',
        checkPass: '',
        accounttype: ''
      },
      codeTimer: 0,
      codeInterval: null,
      registerRules: {
        companyname: [{ required: true, message: '请输入公司名', trigger: 'change' }],
        account: [{ required: true, validator: checkusername, trigger: 'change' }],
        // phonenumber: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        phonenumber: [
          { required: true, validator: checkPhone, trigger: 'change' }
        ],
        code: [{ required: true, validator: checkCode, trigger: 'change' }],
        password: [
          { validator: validatePass, trigger: 'change' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'change' }
        ],
        accounttype: [
          { required: true, message: '请选择账户类型', trigger: 'change' }
        ]
      },
      companynames: [],
      phonemessage: '',
      message: ''
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    loading: function () {
      axios.get('/data/account/getCompanyname').then(res => {
        this.companynames = res.data
        console.log('this.companynames', this.companynames)
      })
    },
    querySearch (queryString, cb) {
      var companynames = this.companynames
      var results = queryString ? companynames.filter(this.createFilter(queryString)) : companynames
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (company) => {
        return (company.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    validate (val) {
      axios.get(`/data/account/validate?account=${val}`).then(res => {
        console.log('message', res)
        this.message = res.data
        if (this.message === '该用户名可用') {
          this.state = 1
        }
      })
    },
    validatePhone (val) {
      axios.get(`/data/account/validatephone?phone=${val}`).then(res => {
        console.log('message', res)
        this.phonemessage = res.data
      })
    },
    // 获取验证码
    getVerificationCode () {
      this.$refs.registerForm.validateField('phonenumber', async (phoneError) => {
        if (!phoneError) {
          axios.get(`/data/register/getcode?phone=${this.registerForm.phonenumber}`).then(res => {
            console.log('res', res)
            this.phonemessage = res.data
            if (res.data === '发短信达上线，请一小时后再试') {
              this.$message.error('发短信达上线，请一小时后再试')
            }
          })
          this.codeTimer = 120
          this.codeInterval = setInterval(() => {
            if (this.codeTimer > 0) {
              this.codeTimer--
            } else {
              clearInterval(this.codeInterval)
            }
          }, 1000)
        }
      })
    },
    // 处理注册
    handleRegister () {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.$message.info('TODO: 调用注册 API...')
          axios.post(`/data/register/account`, this.registerForm).then(res => {
            console.log(res)
            router.push('/')
          })
        } else {
          this.$message.error('请完整填写注册信息')
          return false
        }
      })
    }
  },
  // 清理计时器，防止内存泄漏
  beforeDestroy () {
    clearInterval(this.codeInterval)
  }
}
</script>

<style scoped>
  .register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-image: url('../../assets/images/signin-1.jpg'); /* 假设您的图片放在 src/assets/login_bg.jpg */
    background-size: cover; /* 确保背景图片覆盖整个容器 */
    background-position: center; /* 居中背景图片 */
    background-repeat: no-repeat; /* 不重复背景图片 */
    /*background-color: #f2f6fc;*/
  }
  .register-card {
    width: 480px;
    max-width: 90%;
  }
  .register-footer {
    text-align: right;
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Register.vue